import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../../api';
import "./TermsAndConditions.css"
import Loader from "../../components/common/Loader";

function PrivacyAndPolicy() {
  const [termsUsData, setTermsUsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTermsUsData = async () => {
      try {
        const response = await fetch(`${BASE_URL}core/privacy/`);
        const data = await response.json();

        // Split the description string at each '\n' character
        const modifiedData = data.data.map((item) => {
          const descriptionArray = typeof item.description === 'string' ? item.description.split('\n') : [];
          return { ...item, description: descriptionArray };
        });

        setTermsUsData(modifiedData);
        // console.log(data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };

    fetchTermsUsData();
  }, []);

  if (isLoading) {
    return <Loader text="Loading privacy policy..." />;
  }

  if (!Array.isArray(termsUsData)) {
    return <div>Error: aboutUsData is not an array.</div>;
  }

  return (
    <>    <div className='TermsAndConditions'>
      {termsUsData.map((item) => (
        <div className='tc-container' key={item.id}>
          <h1>{item.title}</h1>
          {/* Check if description is an array before mapping over it */}
          {Array.isArray(item.description) && item.description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      ))}
    </div>

    </>

  );
}

export default PrivacyAndPolicy;
